import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sdc-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit {

  constructor() {
    console.log('Main layout constructor called');
  }

  ngOnInit() {
  }

}
